import React, { useState } from 'react'
import { PastureModal } from '../components/PastureModal'

export const usePastureModal = (pastureId?: string) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  const PastureModalComponent = () =>
    isOpen ? <PastureModal isOpen={true} onClose={close} pastureId={pastureId} /> : null

  return {
    open,
    close,
    isOpen,
    PastureModal: PastureModalComponent
  }
}
